import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import ReactMarkdown from 'react-markdown';
import portrait from '../assets/images/CVPage__jakob_profile_picture.jpg';
import '../pages/CVPage.css';

export default function CVPage({ onBack }) {
  const [introText, setIntroText] = useState('');
  const introTextURL = process.env.PUBLIC_URL + '/content/individual_page_intros/CVPage__intro.md';
  const pdfUrl = process.env.PUBLIC_URL + '/pdf/Jakob Gutzmann CV.pdf';

  useEffect(() => {
    fetch(introTextURL)
      .then(res => res.text())
      .then(setIntroText)
      .catch(console.error);
  }, [introTextURL]);

  return (
    <>
      <Helmet>
          <title>CV | Jakob Gutzmann</title>
      </Helmet>
      <div className="cv-modern-home">
        <section className="cv-modern-header">
          <button onClick={onBack} className="back-link" style={{ marginBottom: '1rem' }}>
            Back to Home
          </button>
        </section>
        <section className="cv-modern-title-section">
          <h1 className="cv-modern-title">About Me</h1>
        </section>
        <div className='cv-home-content'>
          {/* Text section */}
          <div className='cv-text-column'>
            <ReactMarkdown style={{ color: '#444' }}>{introText}</ReactMarkdown>
            <p style={{ marginTop: '1.5rem', textAlign: 'center' }}>
              <a
                href={pdfUrl}
                download
                style={{ textDecoration: 'none', color: '#0039A6', fontWeight: 'bold' }}
              >
                📄 Download CV
              </a>
            </p>
          </div>
          {/* Portrait */}
          <div className='cv-image-column'>
            <img className=''
              src={portrait}
              alt="Jakob Gutzmann"
              style={{ maxHeight: '60vh', borderRadius: '8px', objectFit: 'cover' }}
            />
          </div>
        </div>
      </div>
    </>
  );
}